/**
 * The driver record stores every date as DD-MM-YYYY strings, while Mantine's
 * DateInput works in `Date`. Both directions live here so the approval modal
 * and the document-review prompt cannot drift on the format.
 */

export function toDdMmYyyy(d: Date | null): string | undefined {
  if (!d) return undefined;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()}`;
}

export function fromDdMmYyyy(value?: string): Date | null {
  if (!value) return null;
  const [dd, mm, yyyy] = value.split("-").map(Number);
  if (!dd || !mm || !yyyy) return null;
  const d = new Date(yyyy, mm - 1, dd);
  return Number.isNaN(d.getTime()) ? null : d;
}
